import type { BrandItem, LensIndexItem, LensShowItem } from '@/app/_lens-components/types';

type AdvancedLensIndexItem =
  | (LensIndexItem & { lens_type_name?: string; lens_type?: string })
  | null;

export interface ResolveLensTypeTrackingFieldsParams {
  lensType?: LensShowItem | null;
  brand?: BrandItem | null;
  advancedLensIndexItem?: AdvancedLensIndexItem;
  lensTypeForTracking?: string | null;
}

export interface LensTypeTrackingFields {
  lens_type_name: string;
  lens_type: string;
  lens_brand_name: string;
  lens_brand: string;
}

export const resolveLensTypeTrackingFields = ({
  lensType,
  brand,
  advancedLensIndexItem,
  lensTypeForTracking,
}: ResolveLensTypeTrackingFieldsParams): LensTypeTrackingFields => ({
  lens_type_name:
    advancedLensIndexItem?.lens_type_name || brand?.brand_name || lensType?.lens_name || '',
  lens_type:
    advancedLensIndexItem?.lens_type ||
    lensTypeForTracking ||
    lensType?.sd_lens_type ||
    brand?.lens_type ||
    lensType?.lens_type ||
    '',
  lens_brand_name: brand?.brand_name || '',
  lens_brand: brand?.brand_title || '',
});
